import { types } from 'mobx-state-tree';
import { flagEmojiFromCode } from '../npaper/CountrySelect';

export const Address = types
  .model('Address', {
    id: types.maybe(types.union(types.number, types.string)),
    country: types.maybeNull(types.string),
    address_line1: types.maybeNull(types.string),
    address_line2: types.maybeNull(types.string),
    postal_code: types.maybeNull(types.string),
    city: types.maybeNull(types.string),
  })
  .views((self) => ({
    get flagEmoji() {
      if (!self.country) return undefined;
      return flagEmojiFromCode(self.country);
    },
  }))
  .views((self) => ({
    get description() {
      const parts = [];
      parts.push(
        [self.address_line1, self.address_line2].filter((i) => !!i).join(' ')
      );
      parts.push([self.postal_code, self.city].filter((i) => !!i).join(' '));
      if (self.country) {
        parts.push(self.country);
      }

      let res = parts.filter((p) => !!p).join(', ');
      if (self.flagEmoji) res = `${self.flagEmoji} ${res}`;
      return res;
    },
    get descriptionLines() {
      const parts = [
        self.address_line1,
        self.address_line2,
        [self.postal_code, self.city].filter((i) => !!i).join(' '),
        self.country,
      ].filter((a) => !!a);
      return parts.join('\n');
    },
  }));
